namespace Gamification.Gamification {
    export namespace ProdottiEsperienzePunteggiService {
        export const baseUrl = 'Gamification/ProdottiEsperienzePunteggi';

        export declare function Create(request: Serenity.SaveRequest<ProdottiEsperienzePunteggiRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ProdottiEsperienzePunteggiRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ProdottiEsperienzePunteggiRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ProdottiEsperienzePunteggiRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Gamification/ProdottiEsperienzePunteggi/Create",
            Update = "Gamification/ProdottiEsperienzePunteggi/Update",
            Delete = "Gamification/ProdottiEsperienzePunteggi/Delete",
            Retrieve = "Gamification/ProdottiEsperienzePunteggi/Retrieve",
            List = "Gamification/ProdottiEsperienzePunteggi/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ProdottiEsperienzePunteggiService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
